<style>
 #mytable .el-table__expanded-cell{
      padding:5px 70px 5px 50px !important;
      background-color: #c0c4cc;
 }
</style>
<style scoped>
.signal{
    float: left;
    border: 1px solid #c5c5c5;
    margin-left: 2px;
    width:5px;
}
.signal_green{
    background-color: seagreen;
}
.signal_one{
    height:5px;margin-top:15px;
}
.signal_two{
    height:10px;margin-top:10px;
}
.signal_three{
    height:15px;margin-top:5px;
}
.signal_four{
    height:20px;margin-top:0px;
}
</style>
<template>
    <div id="mytable">
        <el-row class="warp">
            <el-col :span="24" class="warp-breadcrum">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
                    <el-breadcrumb-item>设备管理</el-breadcrumb-item>
                    <el-breadcrumb-item>设备状态</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
            <el-col>
                
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
                <!--工具条-->
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form :inline="true" :model="searchForm" >
                    <el-form-item  label='设备号：'>
                        <el-input v-model="searchForm.deviceCode" placeholder="设备号" maxlength="50" style="width:320px;"></el-input>
                    </el-form-item>
                    <el-form-item label='设备型号'>
                         <el-input v-model="searchForm.deviceSN" placeholder="设备型号" maxlength="50" style="width:320px;"></el-input>
                    </el-form-item>
                     <el-form-item label='设备品类：'>
                        <el-select  v-model="searchForm.deviceCategoryId" placeholder="设备品类" style="width:320px;">
                            <el-option v-for='(item,index) in deviceCategoryDatas' :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备供应商">
                        <el-select  v-model="searchForm.supplierId" placeholder="设备供应商" clearable style="width:320px;">
                            <el-option v-for='(item,index) in allSupplier' :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select> 
                    </el-form-item>
                    <el-form-item label='项目'>
                         <el-select
                            v-model="searchForm.projectId"
                            filterable
                            :filter-method="getMyProject"
                            placeholder="项目"
                            @clear="clearProject"
                            @focus="focusProject"
                            :change="clearProject"
                            clearable
                            style="width:350px;">
                            <el-option
                            v-for="(item,index) in projectSelects"
                            :key="index"
                            :label="item.label"
                            :value="item.value" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='注册时间：'>
                        <el-date-picker
                            v-model="searchForm.registTime"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="注册开始日期"
                            end-placeholder="注册结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width:360px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">查询</el-button>
                        <el-button type="primary" @click="resetForm()">重置</el-button>
                        <el-button type="primary" @click="showAddDialog" v-has-permission="'device:add'">新增</el-button>
                        <el-button type="primary" icon="el-icon-download" @click="handleExport" v-has-permission="'device:export'">导出</el-button>
                        <el-button type="primary" @click="handleMapShow" v-has-permission="'device:devicemap'">地图展示</el-button>
                    </el-form-item>
                    </el-form>
                </el-col>

                <!--列表-->
                <el-table :data="devices" highlight-current-row v-loading="loading" border style="width: 100%;">
                    <el-table-column type="index" label="序号" width="50" fixed="left" align="center"></el-table-column>
                    
                    <el-table-column prop="deviceName" label="设备名" width="260"  align="center" ></el-table-column>
                    <el-table-column prop="deviceCode" label="设备号" width="180"  align="center"></el-table-column>
                    <el-table-column prop="deviceShortcode" label="设备短号" width="180"  align="center"></el-table-column>
                    <el-table-column prop="deviceSupplierCategoryName" label="供应商设备品类" width="180" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="deviceSn" label="设备型号" width="160"  align="center"></el-table-column>
                    <el-table-column prop="currentValue" label="当前值" width="160"  align="center"></el-table-column>
                    <el-table-column prop="deviceWarState" label="报警状态" width="80"  align="center">
                        <template slot-scope="scope">
                            <i v-if="scope.row.deviceWarState === 1" class="fa fa-circle" aria-hidden="true" style="color:green"> 在线</i>
                            <i v-else-if="scope.row.deviceWarState === 2" class="fa fa-circle" aria-hidden="true" style="color:red"> 离线</i>
                            <i v-else-if="scope.row.deviceWarState === 0" class="fa fa-circle" aria-hidden="true" style="color:yellow"> 未知</i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceBattery" label="电池电量" width="80"  align="center">
                        <template slot-scope="scope">
                            <i v-if="scope.row.deviceBattery === 0" class="fa fa-battery-0 " aria-hidden="true" style="color:red"><i class="fa fa-flash" style="position: absolute;left: 35px;color:red"></i></i>
                            <i v-else-if="scope.row.deviceBattery === 1" class="fa fa-battery-4" aria-hidden="true" style="color:green"> </i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceSignal" label="信号强度" width="80"  align="center" >
                       <template slot-scope="scope">
                             <div v-if="scope.row.deviceSignal === 0" >
                                <div class="signal signal_one " ></div>
                                <div  class="signal signal_two"></div>
                                <div  class="signal signal_three" ></div>
                                <div  class="signal signal_four"></div>
                            </div>
                             <div v-if="scope.row.deviceSignal === 1" >
                                <div class="signal signal_one signal_green" ></div>
                                <div  class="signal signal_two"></div>
                                <div  class="signal signal_three" ></div>
                                <div  class="signal signal_four"></div>
                            </div>
                             <div v-if="scope.row.deviceSignal === 2" >
                                <div class="signal signal_one signal_green" ></div>
                                <div  class="signal signal_two signal_green"></div>
                                <div  class="signal signal_three" ></div>
                                <div  class="signal signal_four"></div>
                            </div>
                             <div v-if="scope.row.deviceSignal === 3" >
                                <div class="signal signal_one signal_green" ></div>
                                <div  class="signal signal_two signal_green"></div>
                                <div  class="signal signal_three signal_green" ></div>
                                <div  class="signal signal_four"></div>
                            </div>
                             <div v-if="scope.row.deviceSignal === 4" >
                               <div class="signal signal_one signal_green" ></div>
                                <div  class="signal signal_two signal_green"></div>
                                <div  class="signal signal_three signal_green" ></div>
                                <div  class="signal signal_four signal_green"></div>
                            </div>
                            
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceState" label="使用状态" width="80"  align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.deviceState ===0" style="color:red">未使用</el-tag>
                            <el-tag v-if="scope.row.deviceState ===1" style="color:green">监控中</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="projectName" label="项目名称" width="280" align="center"></el-table-column>
                    <el-table-column prop="deviceSupplierName" label="供应商" width="280" align="center"></el-table-column>
                    <el-table-column prop="addressDetail" label="地址" width="380"  align="center" :formatter="addressFormatter"></el-table-column>
                    <el-table-column prop="devicePosition" label="位置" width="240"  align="center"></el-table-column>
                    <el-table-column prop="deviceLongitude" label="经纬度" width="280"  align="center" :formatter="positionFormatter"></el-table-column>
                    <el-table-column prop="deviceRegisterTime" label="注册时间" width="180"  align="center"></el-table-column>
                    <el-table-column prop="remark" label="备注" width="180"  align="center"></el-table-column>
                    <el-table-column label="操作" fixed="right"  align="center"  width="170" >
                    <template slot-scope="scope" >
                       <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <el-button type="primary" icon="fa fa-pencil-square-o" round size="mini" @click="showEditDialog(scope.$index,scope.row)" style="padding:8px;margin:0;" v-has-permission="'device:update'"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="变更日志" placement="top-start">
                            <el-button type="primary" icon="fa fa-clone" round size="mini" @click="deviceChangeLog(scope.$index,scope.row)"  style="padding:8px;margin:0;"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="注册" placement="top-start">
                            <el-button type="primary" icon="fa fa-registered"  round size="mini" @click="registDevice(scope.$index,scope.row)"  style="padding:8px;margin:0;"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" v-if="scope.row.deviceSupplierCode === 'ZP'"  effect="dark" content="详情" placement="top-start">
                            <el-button type="primary" icon="fa fa-info-circle"  round size="mini" @click="deviceDetail(scope.$index,scope.row)"  style="padding:8px;margin:0;"></el-button>
                        </el-tooltip>
                    </template>
                    </el-table-column>
                </el-table>
                <!--分页工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
                    :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
                    </el-pagination>
                </el-col>

                <!--新增界面-->
                <el-dialog :title="title" :visible.sync="addEditFormVisible" :close-on-click-modal="false">
                    <el-form :model="addEditForm" label-width="130px"  :rules="formRules" ref="addEditForm" >
                        <el-input v-model="addEditForm.id" type="hidden"></el-input>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="设备名称" prop="deviceName">
                                    <el-input v-model.trim="addEditForm.deviceName" placeholder="设备名称" maxlength="100" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="设备号" prop="deviceCode">
                                    <el-input v-model.trim="addEditForm.deviceCode" placeholder="设备号" maxlength="50" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                            <el-form-item label="设备短号" prop="deviceShortcode">
                                <el-input v-model.trim="addEditForm.deviceShortcode" placeholder="设备短号" maxlength="50" show-word-limit auto-complete="off"></el-input>
                            </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="设备供应商" prop="deviceSupplierId">
                                    <el-select v-model="addEditForm.deviceSupplierId" @change="handleSupplierChange" clearable placeholder="设备供应商" style="width:328px;">
                                        <el-option v-for='(item,index) in allSupplier' :key="index" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="供应商设备品类" prop="deviceSupplierCategoryId">
                                    <el-select v-model="addEditForm.deviceSupplierCategoryId" @change="handleSupplierCategoryChange" clearable placeholder="供应商设备品类" style="width:100%;">
                                        <el-option v-for='(item,index) in deviceSupplierCategoryDatas' :key="index" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="设备型号" prop="deviceSn">
                                    <el-input v-model.trim="addEditForm.deviceSn" placeholder="设备型号" maxlength="50" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label='项目' prop="projectId">
                                    <el-select
                                        v-model="addEditForm.projectId"
                                        filterable
                                        :filter-method="getMyProject"
                                        placeholder="项目"
                                        @clear="clearProject"
                                        @focus="focusProject"
                                        :change="clearProject"
                                        clearable
                                        style="width:100%"
                                        >
                                        <el-option
                                        v-for="(item,index) in projectSelects"
                                        :key="index"
                                        :label="item.label"
                                        :value="item.value" >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="位置" prop="devicePosition">
                                    <el-input v-model.trim="addEditForm.devicePosition" placeholder="位置" maxlength="100" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span=24>
                                <el-form-item label="描述" prop="remark">
                                    <el-input type="textarea" v-model="addEditForm.remark" :rows="5" placeholder="描述" maxlength="100" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click.native="addEditFormVisible = false">取消</el-button>
                        <el-button type="primary" @click.native="addEditForm.submit" :loading="loading">提交</el-button>
                    </div>
                </el-dialog>

                 <!--变更日志-->
                <el-dialog title="变更" :visible.sync="deviceChangeVisible" :close-on-click-modal="false" width="80%">
                    <!--列表-->
                    <el-table :data="deviceChanges" highlight-current-row v-loading="loading" border style="width: 100%;">
                        <el-table-column type="index" label="序号" width="50" fixed="left" align="center"></el-table-column>
                        <el-table-column prop="beforeProjectName" label="变更前项目" width="380" align="center"></el-table-column>
                        <el-table-column prop="currentProjectName" label="变更后项目" width="380"  align="center" ></el-table-column>
                        <el-table-column prop="changeDate" label="变更日期" width="250"  align="center"></el-table-column>
                        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                    </el-table>
                </el-dialog>

                <!--显示消防主机-->
                <el-dialog title="消防主机" :visible.sync="fireHost.deviceDetailVisible" :close-on-click-modal="false" width="90%">
                    <!--工具条-->
                    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                         <el-form :inline="true" :model="fireHost.searchForm" >
                        <el-form-item  label='主机号：'>
                            <el-input v-model="fireHost.searchForm.host" placeholder="主机号" maxlength="20" @input="inputChange" style="width:200px;"></el-input>
                        </el-form-item>
                        <el-form-item  label='回路号：'>
                            <el-input v-model="fireHost.searchForm.loop" placeholder="回路号" maxlength="20" @input="inputChange" style="width:200px;"></el-input>
                        </el-form-item>
                        <el-form-item  label='点位号：'>
                            <el-input v-model="fireHost.searchForm.point" placeholder="点位号" maxlength="20" @input="inputChange" style="width:200px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="fireHost.handleSearch">查询</el-button>
                            <el-button type="primary" @click="fireHost.resetForm()">重置</el-button>
                            <el-button type="primary" @click="fireHost.fireHostForm.showAddDialog">新增主机</el-button>
                        </el-form-item>
                        </el-form>
                    </el-col>
                    <!--列表-->
                    <el-table :data="fireHost.data" highlight-current-row v-loading="loading" border style="width: 100%;">
                        <el-table-column type="expand">
                            <template slot-scope="props" style="padding:10px;">
                                <el-table :data="props.row.pointList" :header-cell-style="{background:'#888888',color:'#606266'}" border style="width: 100%;">
                                    <el-table-column prop="loop" label="回路号" width="160" align="center"></el-table-column>
                                    <el-table-column prop="point" label="点位号" width="160"  align="center" ></el-table-column>
                                    <el-table-column prop="deviceName" label="设备名称" width6="200"  align="center"></el-table-column>
                                    <el-table-column prop="deviceSN" label="设备型号" width="200"  align="center"></el-table-column>
                                    <el-table-column prop="position" label="位置" width="350"  align="center"></el-table-column>
                                    <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                                    <el-table-column label="操作" fixed="right"  align="center"  width="70" >
                                        <template slot-scope="scope" >
                                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                                <el-button type="primary" icon="fa fa-pencil-square-o"  round size="mini" @click="fireHost.fireHostForm.showEditPointDiaolog(scope.$index,scope.row)" style="padding:8px;margin:0;"></el-button>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>
                        <el-table-column prop="host" label="主机号" width="200" align="center"></el-table-column>
                        <el-table-column prop="deviceName" label="设备名称" width="250"  align="center" ></el-table-column>
                        <el-table-column prop="deviceSN" label="设备型号" width="250"  align="center" ></el-table-column>
                        <el-table-column prop="position" label="位置" width="400"  align="center"></el-table-column>
                        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
                        <el-table-column label="操作" fixed="right"  align="center"  width="70" >
                            <template slot-scope="scope" >
                            <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                                    <el-button type="primary" icon="fa fa-pencil-square-o"  round size="mini" @click="fireHost.fireHostForm.showEditDialog(scope.$index,scope.row)" style="padding:8px;margin:0;"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="新增点位" placement="top-start">
                                    <el-button type="primary" icon="fa fa-plus-circle"  round size="mini" @click="fireHost.fireHostForm.showAddPointDiaolog(scope.$index,scope.row)"  style="padding:8px;margin:0;"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-dialog>

                <!--添加主机和点位-->
                <el-dialog :title="fireHost.title" :visible.sync="fireHost.fireHostVisible" :close-on-click-modal="false">
                    <el-form :model="fireHost.fireHostForm" label-width="100px"  :rules="fireHost.fireHostRules" ref="fireHost.fireHostForm" >
                        <el-input v-model="fireHost.fireHostForm.data.id" type="hidden"></el-input>
                        <el-row>
                            <el-col :span="8" v-if="!fireHost.showPoint">
                                <el-form-item label="主机号" prop="host">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.host" placeholder="主机号" maxlength="20" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="fireHost.showPoint">
                                <el-form-item label="点位号" prop="point">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.point" placeholder="点位号" maxlength="20" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="fireHost.showPoint">
                                <el-form-item label="回路号" prop="loop">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.loop" placeholder="回路号" maxlength="20" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="设备名称" prop="deviceName">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.deviceName" placeholder="设备名称" maxlength="20" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="设备型号" prop="deviceSN">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.deviceSN" placeholder="设备型号" maxlength="20" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                             <el-col :span="24">
                                <el-form-item label="地址" prop="address">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.address" placeholder="地址" maxlength="100" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="位置" prop="position">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.position" placeholder="位置" maxlength="100" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="经度" prop="longitude">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.longitude" placeholder="经度" maxlength="12" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="纬度" prop="latitude">
                                    <el-input v-model.trim="fireHost.fireHostForm.data.latitude" placeholder="纬度" maxlength="12" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span=24>
                                <el-form-item label="备注" prop="remark">
                                    <el-input type="textarea" v-model="fireHost.fireHostForm.data.remark" :rows="5" placeholder="备注" maxlength="255" show-word-limit auto-complete="off"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click.native="fireHost.fireHostVisible = false">取消</el-button>
                        <el-button type="primary" @click="fireHost.fireHostForm.submit()"  >提交</el-button>
                    </div>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { saveAs } from 'file-saver';
import DEVICE_API from '../../api/api_device';
import PROJECT_API from '../../api/api_project';
export default {
    data(){
      return{
        devices:[],
        allSupplier:[],
        deviceChanges:[],
        projectSelects:[],
        loading:false,
        total: 0,
        page: 1,
        limit: 10,
        title:"",
        addEditFormVisible:false,
        deviceChangeVisible:false,
        
        fireHost:{
            deviceDetailVisible:false,
            fireHostVisible:false,
            searchForm:{host:''},
            data:[],
            handleSearch:function(){},
            resetForm:function(){},
            title:"",
            showPoint:false,
            fireHostForm:{
                data:{},
                //显示新增消防主机
                showAddDialog:function(){},
                showEditDialog:function(){},
                showAddPointDiaolog:function(){},
                showEditPointDiaolog:function(){},
                submit:function(){},
            },

            fireHostRules:{},
        },

        addEditForm:{},
        
        //查询条件
        searchForm: {},
        deviceCategoryDatas: [],
        deviceSupplierCategoryDatas: [],
        useState:[
            {label:"监控中",value:"1"},
            {label:"未使用",value:"0"},
        ],
        eventType:[
            {label:"离线",value:"0"},
            {label:"在线",value:"1"},
            {label:"异常",value:"2"}
        ],
        deviceMapParams: {},
        
        formRules: {
            deviceName:[
                {required: true, message: '请输入设备名称', trigger: ['blur','change']}
            ],
            deviceSupplierId: [
                {required: true, message: '请选择设备供应商', trigger: ['blur','change']}
            ],
            deviceCode: [
                {required: true, message: '请输入设备号', trigger: ['blur','change']}
            ],
            deviceShortcode: [
                {required: true, message: '请输入设备短号', trigger: ['blur','change']}
            ],
            deviceSupplierCategoryId: [
                {required: true, message: '请选择供应商设备品类', trigger: ['blur','change']}
            ],
            deviceSn: [
                {required: true, message: '请输入设备型号', trigger: ['blur','change']}
            ],
            projectId: [
                {required: true, message: '请选择项目', trigger: ['blur','change']}
            ]
        },
       
      }
    },
    methods: {
        //供应商设备品类change事件
        handleSupplierCategoryChange(value) {
            let that = this;
            var selectValue=value;
            let temp = that.deviceSupplierCategoryDatas.find(item=>item.id==value);
            that.addEditForm.deviceSn = temp.type;
        },
        supplierSelect:function(){
          let that = this;
          DEVICE_API.allSupplier({})
          .then(
              function(result) {
                if (result && result.code == 200) {
                  that.allSupplier= result.data;
                }
              },
              function(error) {
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error){
              that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
              });
            });
        },
        handleSupplierChange: function(value){
          let that = this;
          this.$delete(this.addEditForm,'deviceSupplierCategoryId');
          this.$delete(this.addEditForm,'deviceSn');
          if (!value) {
            this.deviceSupplierCategoryDatas = [];
            return;
          }
          this.deviceSupplierCategoryCombox(value);
        },
        resetForm:function(){
            this.searchForm={};
        },
        addressFormatter:function(row,column){
            return row.provinceName+row.cityName+row.districtName+row.addressDetail;
        },
        positionFormatter:function(row,column){
            return (row.deviceLongitude?row.deviceLongitude:"")+","+(row.deviceLatitude?row.deviceLatitude:"");
        },
        deviceCategoryCombox: function() {
          let that = this;
          DEVICE_API.deviceCategoryCombox({})
          .then(
            function(result){
              if (result && result.code == 200) {
                that.deviceCategoryDatas = result.data;
              }
            },
            function(error){
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
              });
          });
        },
        deviceSupplierCategoryCombox: function(supplierId){
          let that = this;
          DEVICE_API.deviceSupplierCategoryCombox(supplierId)
          .then(
            function(result){
              if (result && result.code == 200) {
                that.deviceSupplierCategoryDatas = result.data;
              }
            },
            function(error){
              that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.$message.error({
              showClose: true,
              message: '请求出现异常!',
              duration: 2000
            });
          });
        },
        getMyProject:function(query,callback){
          let that = this;
          PROJECT_API.getMyProject({projectName:query?query:""})
          .then(
            function(result){
            if (result && result.code == 200) {
               that.projectSelects = result.data;
               if(callback) {
                   callback();
               }
            }
            },
            function(error){
            that.$message.error({
                showClose: true,
                message: error.toString(),
                duration: 2000
            });
            }
          )
          .catch(function(error){
            that.$message.error({
            showClose: true,
            message: '请求出现异常!',
            duration: 2000
            });
          });
      },
      clearProject:function(){
        this.getMyProject();
      },
      focusProject:function(){
          if(!this.searchForm.projectId){
              this.getMyProject()
          }
          
      },
      //分页切换每页条数
      handleSizeChange:function(val){
        this.limit = val;
        this.search();
      },
      //分页切换页码
      handleCurrentChange:function(val){
        this.page = val;
        this.search();
      },
      //查询按钮
      handleSearch:function(){
        this.page=1;
        this.total=0;
        this.search();
      },
      //查看变更日志
      deviceChangeLog:function(index,row){
        let that = this;
        that.deviceChangeVisible=true;
        DEVICE_API.deviceChangeLog({deviceId:row.id})
            .then(
                function(result){
                if (result && result.code == 200) {
                    that.deviceChanges = result.data;
                }
                },
                function(error){
                that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                });
                }
            )
            .catch(function(error){
                that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
                });
            });
      },
      registDevice:function(index,row){
          let that = this;
          //若已注册则提示
          if(row.deviceRegistFlag)
          {
              that.$message.error({
                    showClose: true,
                    message: "设备已注册",
                    duration: 2000
                });
                return;
          }
          DEVICE_API.registDevice(row.id)
            .then(
                function(result){
                    if (result && result.code == 200) {
                        that.search();
                    }
                },
                function(error){
                that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                });
                }
            )
            .catch(function(error){
                that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
                });
            });
      },
      //设备详情
      deviceDetail:function(index,row)
      {
        let that = this;
        that.fireHost.deviceDetailVisible=true;
        that.fireHost.searchForm.host="";
        that.fireHost.searchForm.loop = "";
        that.fireHost.searchForm.point = "";
        //查询方法
        that.fireHost.handleSearch=function(){
            //查询数据
            DEVICE_API.getHostPointList({
                deviceId:row.id,
                host:that.fireHost.searchForm.host,
                loop: that.fireHost.searchForm.loop,
                point: that.fireHost.searchForm.point
            })
            .then(
                function(result){
                    console.log(result);
                    if (result && result.code == 200) {
                        that.fireHost.data=result.data;
                    }
                },
                function(error){
                    that.$message.error({
                        showClose: true,
                        message: error.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function(error){
                    that.$message.error({
                    showClose: true,
                    message: '请求出现异常!',
                    duration: 2000
                    });
                });
        };
        //重置
        that.fireHost.resetForm=function(){
            that.fireHost.searchForm.host="";
            that.fireHost.searchForm.loop = "";
            that.fireHost.searchForm.point = "";
            that.$forceUpdate();
        };
        
        //调用查询
        that.fireHost.handleSearch();

        //实现新增一级设备——消防主机
        that.fireHost.fireHostForm.showAddDialog=function()
        {
            that.fireHost.fireHostVisible=true;//显示界面
            that.fireHost.title='添加主机';//标题名称
            that.fireHost.showPoint=false;
            that.fireHost.fireHostForm.data={};
            //实现提交
            that.fireHost.fireHostForm.submit=function()
            {
                let params = Object.assign({}, that.fireHost.fireHostForm.data);
                params.type=1;//主机
                params.deviceId=row.id;
                console.log(params);
                //保存
                DEVICE_API.insertHostOrPint(params)
                .then(
                    function(result){
                        console.log(result);
                        if (result && result.code == 200) {
                            that.fireHost.fireHostVisible=false;
                            that.fireHost.data.push(result.data);
                        }
                    },
                    function(error){
                        that.$message.error({
                            showClose: true,
                            message: error.toString(),
                            duration: 2000
                        });
                        }
                    )
                    .catch(function(error){
                        that.$message.error({
                        showClose: true,
                        message: '请求出现异常!',
                        duration: 2000
                        });
                    });
            }
        }
        //修改消防主机
        that.fireHost.fireHostForm.showEditDialog=function(index,myrow){
            that.fireHost.fireHostVisible=true;
            that.fireHost.title='编辑主机';
            that.fireHost.showPoint=false;
            that.fireHost.fireHostForm.data={};
            that.fireHost.fireHostForm.data= Object.assign({}, myrow);
            //实现提交
            that.fireHost.fireHostForm.submit=function()
            {
                  let params = Object.assign({}, that.fireHost.fireHostForm.data);
                  params.type=1;//主机
                  console.log(params);
                   //保存
                    DEVICE_API.editHostOrPoint(params)
                    .then(
                        function(result){
                            if (result && result.code == 200) {
                                that.fireHost.fireHostVisible=false;
                                myrow.host = params.host;
                                myrow.deviceName = params.deviceName;
                                myrow.deviceSN = params.deviceSN;
                                myrow.address= params.address;
                                myrow.position = params.position;
                                myrow.longitude = params.longitude;
                                myrow.latitude= params.latitude;
                                myrow.remark = params.remark;
                            }
                        },
                        function(error){
                            that.$message.error({
                                showClose: true,
                                message: error.toString(),
                                duration: 2000
                            });
                            }
                        )
                        .catch(function(error){
                            that.$message.error({
                            showClose: true,
                            message: '请求出现异常!',
                            duration: 2000
                            });
                        });
            }
        },
        //新增二级设备——点位
        that.fireHost.fireHostForm.showAddPointDiaolog=function(index,myrow)
        {
            that.fireHost.fireHostVisible=true;
            that.fireHost.title='添加点位';
            that.fireHost.showPoint=true;
            that.fireHost.fireHostForm.data={};
            //实现提交
            that.fireHost.fireHostForm.submit=function()
            {
                let params = Object.assign({}, that.fireHost.fireHostForm.data);
                params.type=2;//点位
                params.deviceId=row.id;
                params.host = myrow.host;
                console.log(params);
                //保存
                DEVICE_API.insertHostOrPint(params)
                .then(
                    function(result){
                        console.log(result);
                        if (result && result.code == 200) {
                            that.fireHost.fireHostVisible=false;
                            //添加到记录中
                            myrow.pointList.push(result.data);
                        }
                    },
                    function(error){
                        that.$message.error({
                            showClose: true,
                            message: error.toString(),
                            duration: 2000
                        });
                        }
                    )
                    .catch(function(error){
                        that.$message.error({
                        showClose: true,
                        message: '请求出现异常!',
                        duration: 2000
                        });
                    });
            }
        }
        //修改点位
        that.fireHost.fireHostForm.showEditPointDiaolog=function(pointIndex,pointRow)
        {
            that.fireHost.fireHostVisible=true;
            that.fireHost.title='编辑点位';
            that.fireHost.showPoint=true;
            that.fireHost.fireHostForm.data={};
            that.fireHost.fireHostForm.data= Object.assign({}, pointRow);
            //实现提交
            that.fireHost.fireHostForm.submit=function()
            {
                 let params = Object.assign({}, that.fireHost.fireHostForm.data);
                  params.type=2;//点位
                  console.log(params);
                //保存
                DEVICE_API.editHostOrPoint(params)
                    .then(
                        function(result){
                            if (result && result.code == 200) {
                                that.fireHost.fireHostVisible=false;
                                pointRow.loop = params.loop;
                                pointRow.point = params.point;
                                pointRow.deviceName = params.deviceName;
                                pointRow.deviceSN = params.deviceSN;
                                pointRow.address= params.address;
                                pointRow.position = params.position;
                                pointRow.longitude = params.longitude;
                                pointRow.latitude= params.latitude;
                                pointRow.remark = params.remark;
                            }
                        },
                        function(error){
                            that.$message.error({
                                showClose: true,
                                message: error.toString(),
                                duration: 2000
                            });
                            }
                        )
                        .catch(function(error){
                            that.$message.error({
                            showClose: true,
                            message: '请求出现异常!',
                            duration: 2000
                            });
                        });
            }
        }
      },
      
      //查询方法
      search:function(){
      	let that = this;
        let params = Object.assign({
            page: that.page,
            limit: that.limit,
        }, that.searchForm);
        params.registStartTime=params.registTime?params.registTime[0]:"";
        params.registEndTime=params.registTime?params.registTime[1]:"";
        params.registTime=undefined;

        this.deviceMapParams = Object.assign({},{
          deviceCode: this.searchForm.deviceCode,
          deviceSN: this.searchForm.deviceSN,
          deviceCategoryId: this.searchForm.deviceCategoryId,
          supplierId: this.searchForm.supplierId,
          projectId: this.searchForm.projectId,
          registStartTime: this.searchForm.registTime ? this.searchForm.registTime[0]: undefined,
          registEndTime: this.searchForm.registTime ? this.searchForm.registTime[1]: undefined
        });

          DEVICE_API.devicePageList(params)
            .then(
                function(result){
                if (result && result.code == 200) {
                    that.total=result.data.total;
                    that.devices = result.data.records;
                  
                }
                },
                function(error){
                that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                });
                }
            )
            .catch(function(error){
                that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
                });
            });
       },

       //新增
       showAddDialog: function () {
           let that =this;
           that.title="新增";
           that.addEditFormVisible=true;
            that.addEditForm={};
           that.addEditForm.submit=function(){
                that.$refs.addEditForm.validate((valid) => {
                    if(valid){
                        DEVICE_API.saveDevice(that.addEditForm)
                            .then(
                                function(result){
                                if (result && result.code == 200) {
                                    that.addEditFormVisible=false;
                                    that.search();
                                }
                                },
                                function(error){
                                that.$message.error({
                                    showClose: true,
                                    message: error.toString(),
                                    duration: 2000
                                });
                                }
                            )
                            .catch(function(error){
                                that.$message.error({
                                showClose: true,
                                message: '请求出现异常!',
                                duration: 2000
                                });
                            });
                    }
                });
               
           }
       },
       //修改、编辑
        showEditDialog:function(index,row){
            let that =this;
           that.title="编辑";
           that.addEditFormVisible=true;
           //查询设备信息
           DEVICE_API.deviceDetail({id:row.id})
            .then(
                function(result){
                    if (result && result.code == 200) {
                        that.addEditForm=result.data;
                        that.getMyProject("",function(){
                            that.addEditForm.projectId = result.data.projectId;
                        });
                        that.deviceSupplierCategoryCombox(that.addEditForm.deviceSupplierId);
                        //编辑保存
                        that.addEditForm.submit=function(){
                             that.$refs.addEditForm.validate((valid) => {
                                 if(valid){
                                    DEVICE_API.updateDevice(that.addEditForm)
                                        .then(
                                            function(result){
                                            if (result && result.code == 200) {
                                                that.addEditFormVisible=false;
                                                that.search();
                                            }
                                            },
                                            function(error){
                                            that.$message.error({
                                                showClose: true,
                                                message: error.toString(),
                                                duration: 2000
                                            });
                                            }
                                        )
                                        .catch(function(error){
                                            that.$message.error({
                                            showClose: true,
                                            message: '请求出现异常!',
                                            duration: 2000
                                            });
                                        });
                                        }
                             });
                            
                        }
                    }
                },
                function(error){
                that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                });
                }
            )
            .catch(function(error){
                that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
                });
            });
        },
      handleExport() {
        let params = Object.assign({}, this.searchForm);
        params.registStartTime = params.registTime? params.registTime[0]: "";
        params.registEndTime = params.registTime? params.registTime[1]: "";
        params.registTime = undefined;
        this.$confirm('是否确认导出所有设备数据?', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          return DEVICE_API.exportDevice(params);
        }).then(result => {
          let fileName = '设备状态.xlsx'; //下载后文件名
          let blob = new Blob([result], { type: 'application/vnd.ms-excel;charset=utf-8'});
          saveAs(blob, fileName);
        })
      },
      inputChange() {
        this.$forceUpdate();
      },
      handleMapShow() {
        this.$router.push({path: '/device/deviceMap',query: this.deviceMapParams})
      }
    },
    //页面load加载
    mounted() {
      this.supplierSelect();
      this.deviceCategoryCombox();
      this.handleSearch();
    }
}
</script>


// WEBPACK FOOTER //
// device.vue?df625864